import React from 'react'
import './_mouse.scss'

const scrollBottom = () => {
  document.querySelector('.FullMenu .inner').scrollIntoView({
    behavior: 'smooth'
  })
}
const Mouse = props => (
  <div className="mouse_div">
    <div id="mouse-scroll">
      <div onClick={() => scrollBottom()}>
        <span className="down-arrow-1" />
        <span className="down-arrow-2" />
        <span className="down-arrow-3" />
      </div>
    </div>
  </div>
)

export default Mouse



// WEBPACK FOOTER //
// ./src/components/mouse/index.js